import { createLocale } from "./createLocale";

export const bg = createLocale({
  header: {
    title: "Излезте глобално. $2 на Short. Всеки език!",
    subtitle: "🔥Плащайте само за резултат – от $0.089 до $0.009 за секунда🔥",
  },
  steps: {
    uploadVideo: "Качете видео",
    selectLanguages: "Изберете езици",
    conversionResult: "Конвертиране и резултат",
  },
  upload: {
    dragAndDrop: "Плъзнете и пуснете видеофайла си тук",
    orClickToSelect: "или кликнете, за да изберете",
    supportedFormats: "Поддържани формати: MP4, AVI, MOV, MKV, WebM",
    maxFileSize: "• Максимален размер на файла: 200 MB",
    maxDuration: "• Максимална продължителност: 30 сек",
    chooseFile: "Изберете файл",
    selectedFile: "Избран файл:",
    size: "Размер:",
    fileTypeError: "Моля, изберете видеофайл",
    fileSizeError: "Размерът на файла ({size} MB) надвишава максималния лимит от 200 MB",
    durationError: "Продължителността на видеото ({duration} сек) надвишава максималния лимит от 30 сек",
    fileReadError: "Видео файлът не може да бъде прочетен. Моля, опитайте друг файл.",
  },
  languages: {
    sourceAudioLanguage: "Език на оригиналното аудио",
    targetAudioLanguage: "Език на целевото аудио",
    selectLanguage: "Изберете език...",
  },
  conversion: {
    replaceAudio: "Клонирай гласа ми",
    uploadVideoAndSelectLanguages: "Качете видео и изберете езици, за да продължите",
  },
  nav: {
    blog: "Блог",
  },
  footer: {
    privacyPolicy: "Политика за поверителност",
    termsOfUse: "Условия за ползване",
  },
  languageOptions: {
    bg: "Български",
  },
});
